<script setup lang="ts">
import { loadStripe, type StripeEmbeddedCheckout } from '@stripe/stripe-js'

defineOptions({ name: 'StripePaymentClient' })

interface Props {
  priceId?: string
  mode?: string
  requireShipping?: boolean
  customerEmail?: string
  userId: string
  returnUrl?: string
}

const props = defineProps<Props>()

const checkoutInstance = ref<StripeEmbeddedCheckout | null>(null)

const { createCheckoutSession } = useApi()

onMounted(async (): Promise<void> => {
  console.log('onMounted')

  const config = useRuntimeConfig()
  console.log(config)

  // const fetchClientSecret = async () => {
  //   const response = await $fetch(
  //     `${config.public.serviceDomain}/api/create-checkout-session`,
  //     {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: {
  //         priceId: props.priceId || 'price_1PFxeaDgAcUdZGogmmV5z1Nl',
  //         quantity: 1,
  //         mode: props.mode,
  //         requireShipping: props.requireShipping,
  //         customerEmail: props.customerEmail,
  //         userId: props.userId,
  //         sceneId: props.sceneId,
  //         returnUrl: (
  //           props.returnUrl
  //             ? (props.returnUrl.startsWith('http') ? props.returnUrl : `${config.public.serviceDomain}${props.returnUrl}`)
  //             : window.location.href
  //         ),
  //       },
  //     },
  //   )
  //   console.log(response)
  //   return response.clientSecret!
  // }

  const fetchClientSecret = async () => {
    return createCheckoutSession(
      {
        priceId: props.priceId || 'price_1PFxeaDgAcUdZGogmmV5z1Nl',
        mode: props.mode,
        // requireShipping: props.requireShipping,
        // customerEmail: props.customerEmail,
        // userId: props.userId,
        returnUrl: props.returnUrl,
      },
    )
  }

  const stripe = await loadStripe(config.public.stripePublishableKey)

  if (!stripe) {
    console.error('Failed to load Stripe')
    return
  }

  const checkout = await stripe?.initEmbeddedCheckout({
    fetchClientSecret,
  })

  console.log(checkout)
  checkout?.mount('#checkoutContainer')
  checkoutInstance.value = checkout
})

onUnmounted(() => {
  console.log('onUnmounted')

  if (checkoutInstance.value) {
    checkoutInstance.value.unmount()
    checkoutInstance.value.destroy()
  }
})
</script>

<template>
  <div id="checkoutContainer" />
  <v-sheet
    class="text-caption pa-1"
    color="blue-grey-lighten-5"
  >
    Code &
    Magicでは、stripe社の決済システムを使用しています。カード情報はstripeにより暗号化されて安全に管理され、当社には知らされません。住所は税務のためstripeにより安全に管理され、当社には配送のためにのみ共有されます。
    価格には送料と税が含まれています。
  </v-sheet>
</template>
